<template>
  <b-form-group :label="label" :label-class="required ? 'required' : ''">
    <b-form-textarea
      v-model="internalValue"
      :required="required ? 'required' : ''"
      :rows="rows"
      :placeholder="`${label} را وارد نمایید`"
    ></b-form-textarea>
    <b-form-invalid-feedback id="input-1-live-feedback">
      {{ label }} ضروری است
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: "Rtextarea",
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    rows: {
      default: "6"
    },
    required: {
      type: Boolean,
      default: false
    }
  }
};
</script>
